import { useEffect, useState } from "react";
import { useLocalization } from "../../../context/LocalizationContext";
import Modal from "../../shared/Modal";
import "./VisualMediaModal.css";

const VisualMediaModal = ({ isOpen, onClose, name, files }) => {
  const { t } = useLocalization();
  const allFiles = files || [];
  const imageFiles = allFiles.filter((f) => f.contentType?.startsWith("image/"));
  const audioFiles = allFiles.filter((f) => f.contentType?.startsWith("audio/"));

  const [imageIndex, setImageIndex] = useState(0);

  useEffect(() => {
    if (isOpen) {
      setImageIndex(0);
    }
  }, [isOpen, name]);

  // Clamped defensively: `imageIndex` can still point past the end of a newly
  // clicked card's (shorter) imageFiles for one render, before the effect
  // above resets it — this avoids reading .fileUrl off undefined that tick.
  const safeImageIndex = Math.min(imageIndex, Math.max(imageFiles.length - 1, 0));

  const showPrevImage = () => setImageIndex((i) => (i - 1 + imageFiles.length) % imageFiles.length);
  const showNextImage = () => setImageIndex((i) => (i + 1) % imageFiles.length);

  return (
    <Modal isOpen={isOpen} onClose={onClose} customLayout noScroll title={null} message={null}>
      <div className="visual-media-modal-body">
        <h2 className="visual-media-modal-title">{name}</h2>

        {imageFiles.length > 0 && (
          <div className="visual-media-image-viewer">
            {imageFiles.length > 1 && (
              <button
                type="button"
                className="visual-media-nav-btn visual-media-nav-btn--prev"
                onClick={showPrevImage}
                aria-label="Previous image"
              >
                <span className="visual-media-nav-chevron visual-media-nav-chevron--left" />
              </button>
            )}
            <img
              key={imageFiles[safeImageIndex].id ?? imageFiles[safeImageIndex].fileUrl}
              src={imageFiles[safeImageIndex].fileUrl}
              alt={name}
              className="visual-media-image"
            />
            {imageFiles.length > 1 && (
              <button
                type="button"
                className="visual-media-nav-btn visual-media-nav-btn--next"
                onClick={showNextImage}
                aria-label="Next image"
              >
                <span className="visual-media-nav-chevron visual-media-nav-chevron--right" />
              </button>
            )}
            {imageFiles.length > 1 && (
              <div className="visual-media-counter">{`${safeImageIndex + 1} / ${imageFiles.length}`}</div>
            )}
          </div>
        )}

        {audioFiles.length > 0 && (
          <div className="visual-media-audio-list">
            {audioFiles.map((file, index) => (
              <div key={file.id ?? file.fileUrl} className="visual-media-audio-item">
                <span className="visual-media-audio-label">{`${name} ${index + 1}`}</span>
                <audio controls src={file.fileUrl} />
              </div>
            ))}
          </div>
        )}

        {imageFiles.length === 0 && audioFiles.length === 0 && (
          <div className="visual-media-empty">{t("vitalsCheck.visualMediaEmpty")}</div>
        )}
      </div>
    </Modal>
  );
};

export default VisualMediaModal;
